package fr.frux.core.common.platform

/**
 * Plateforme déclarée au serveur. Elle sert à choisir la variante de sollicitation et à pouvoir
 * éteindre une plateforme sans republier (spec 2026-08-13). Elle ne doit jamais servir à brancher
 * du comportement métier, qui doit rester commun. Seule exception, les règles des magasins
 * d'applications ([donationsAllowed]).
 *
 * Les valeurs correspondent aux entrées de `SupportPlatform` côté serveur.
 */
expect val platformId: String

/**
 * Plateformes où aucune surface de don ne doit apparaître (#473). La politique Paiements de Play
 * réserve l'exception « dons » aux organismes caritatifs, et l'App Store applique la même règle.
 * Côté client plutôt que seulement par `SUPPORT_DISABLED_PLATFORMS` : la ligne du profil ne
 * dépend pas du serveur, et un build publié ne doit pas pouvoir afficher un lien de don même si la
 * configuration serveur manque.
 */
private val DONATION_FREE_PLATFORMS = setOf("ANDROID", "IOS")

/** Vrai si la plateforme [platform] peut afficher la cagnotte de dons (#473). */
fun donationsAllowedOn(platform: String): Boolean = platform !in DONATION_FREE_PLATFORMS

/** Vrai si la plateforme courante peut afficher la cagnotte de dons (#473). */
val donationsAllowed: Boolean get() = donationsAllowedOn(platformId)
